<template>
    <div>
        <van-popup v-model="contShow" round position="bottom" :style="{ maxHeight: '24rem' }">
            <div class="agreement_box">
            <div class="agreement_title">参拍协议</div>
            <div class="agreement_con" v-html="xieyiData.detail"></div>
            <div class="agreement_bottom">
                <!-- <van-checkbox v-model="checked" checked-color="#07c160">{{xieyiData.concise_official}}</van-checkbox> -->
                <div class="agreement_ts">{{xieyiData.concise_official}}</div>
                <van-button round type="primary" size="normal" block style="margin-top:0.4rem;" :disabled="!checked" @click="tyi">同意</van-button>
            </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    props:["xieyiData","agreementShow"],
    data() {
        return {
            contShow:this.agreementShow, //显示
            checked: true,
            //xieyiData:this.xieyiData,
        };
    },
    methods: {
        agreementFun(show){
            this.contShow=show;
        },
        tyi(){
            this.$parent.getBidAgreementTyi();
            this.contShow=false;
        },
    },
};
</script>

<style lang="scss" scoped>
.agreement_box{
    width:100%;
    height:auto;
    padding:0.6rem;
}
.agreement_title{
    width:100%;
    line-height:1.1rem;
    font-size:0.8rem;
    color:#27282D;
    text-align:center;
    font-weight:bold;
    margin-top:0.2rem;
    margin-bottom:0.2rem;
}
.agreement_con{
    width:100%;
    line-height:1rem;
    font-size:0.7rem;
    color:#27282D;
    max-height:15.7rem;
    overflow-x:hidden;
    overflow-y:auto;
    padding-right:0.2rem;
}
.agreement_con p{
    margin-bottom:0.4rem;
}
.agreement_bottom{
    width:100%;
    padding:0.5rem;
}
.agreement_ts{
    width:100%;
    line-height:1rem;
    font-size:0.5rem;
    color:#666;
}
</style>